module.exports = __webpack_public_path__ + "assets/logo_navbar.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_navbar.svg
 ** module id = 142
 ** module chunks = 1
 **/